export default "__VITE_ASSET__DE5FrY9g__"